import { FC } from 'react'
import { Navigate, matchPath, useLocation } from 'react-router-dom'

import { Path } from 'constants/router'
import { PurchaseFlow } from 'components/pages/PurchaseFlow'

import { EmbedPurchaseFlowGuard } from '../EmbedPurchaseFlowGuard/EmbedPurchaseFlowGuard'

/**
 * The embed's legacy flow, for when the revamp is switched off.
 *
 * Legacy recognises the embed only on the bare embed path, so an iframe left on one of the revamp's
 * sub-paths (a reload or Back after the switch) would mount legacy outside embed mode — without the
 * consent gate. Such a path goes back to the bare one, keeping the launch query.
 */
export const LegacyEmbedPurchaseFlow: FC = () => {
  const { pathname, search } = useLocation()
  if (!matchPath(Path.EMBED_PURCHASE_FLOW, pathname)) {
    return <Navigate to={{ pathname: Path.EMBED_PURCHASE_FLOW, search }} replace />
  }
  return <EmbedPurchaseFlowGuard component={PurchaseFlow} />
}
